<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/association-introduction">关于我们</router-link></li>
                <li class="currentNode"><a>协会简介</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>关于我们</a></li>
                    <li><router-link to="" class="active">协会简介</router-link></li>
                    <li><router-link to="/layout/association-articles">协会章程</router-link></li>
                    <li><router-link to="/layout/association-structure">协会构架</router-link></li>
                    <li><router-link to="/layout/join-us">申请入会</router-link></li>
                    <li><router-link to="/layout/call">联系方式</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>协会简介</h3>
                    <div class="noContentDetail" v-html="content"></div>
                    <!-- <p>河南省人民政府驻北京办事处是省委、省政府派驻北京的综合性办事机构。主要职责为：</p>
                    <p>（一）承办中央和国家机关安排的重要会议，参与我省在京重大活动的组织、协调、服务工作，承办我省需要在北京办理的事项。</p>
                    <p>（二）负责收集编报有关政治、经济、社会等方面的信息，分析研究京津冀地区经济发展、合作动态、宏观经济政策及产业规划，为省委、省政府决策和经济社会高质量发展提供信息服务。</p>
                    <p>（三）贯彻落实国家及河南招商引资和对外开放合作发展战略、政策，负责我省在京津冀地区的招商引资、产品推介工作，承担我省对外开放合作发展项目的发布、推介，负责承接京津冀地区产业转移的指导、联系、对接工作。</p>
                    <p>（四）负责与中央和国家机关、中央企业、外国驻华使馆、驻京商协会以及京津冀地区地方党委、政府及有关部门、企事业单位的对接联系，推动区域间经济合作和文化交流，负责京津冀地区豫商协会（企业联合会）的联系服务工作。</p>
                    <p> 近年来，河南省人民政府驻北京办事处先后被中央文明委、首都文明委、中央和国家机关文明办评为全国文明单位、首都文明单位标兵、中央国家机关文明单位标兵，被中央和国家机关工委授予中央国家机关先进基层党组织，被团中央授予全国五四红旗团委创建单位，被国家保密局授予全国保密工作先进单位等多项荣誉称号，在信息、经协、服务、安全、节水、绿化等领域被国管局、北京市和河南省授予荣誉称号。</p> -->
                    <h3>协会工作部</h3>
                    <ul class="association-list">
                        <li class="association-item">
                            <router-link to="/layout/info-branch-introduction?id=1">
                                <img src="@/assets/image/association/1.png" />
                                <p>信息工作部</p>
                            </router-link>
                        </li>
                        <li class="association-item">
                            <router-link to="/layout/info-branch-introduction?id=2">
                                <img src="@/assets/image/association/2.png" />
                                <p>双招双引工作部</p>
                            </router-link>
                        </li>
                        <li class="association-item">
                            <router-link to="/layout/info-branch-introduction?id=3">
                                <img src="@/assets/image/association/3.png" />
                                <p>医疗卫生工作部</p>
                            </router-link>
                        </li>
                        <li class="association-item">
                            <router-link to="/layout/info-branch-introduction?id=4">
                                <img src="@/assets/image/association/4.png" />
                                <p>企业工作部</p>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getXiehuiModel,
} from '@services/indexService.js'
export default {
    name:"",
    data() {
        return {
            id: 5, // 5
            content: "",
        }
    },
    created() {
        this.getXiehuiModel();
    },
    methods: {
        handleCurrentChange(pageNum) {

        },
        getXiehuiModel() {
            let params = {
                id: this.id
            };
            getXiehuiModel(params).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.content = res.Data.Saler;
                } else {
                    this.$message.error("协会简介请求失败");
                }
            })
        }
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
}
.page-content h3{
    text-align:center;
}
.page-content p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    margin-bottom: 20px;
    width: 100%;
    text-indent: 2em;
}
.page-content p:nth-of-type(1){
    text-indent: 0;
}
.association-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.association-item a {
    display: block;
    width: 216px;
    height: 116px;
    background: #F3F3F3;
    color: #4E5969;
    font-size: 20px;
    text-align:center;
    padding-top: 20px;
    box-sizing: border-box;
}
</style>